let decimal = {
    decimal: true,
    decimalPlaces: 2
};

let positiveDecimal = {...decimal, negative: false };
let negativeDecimal = {...decimal, negative: true };

export let editorOptions = {
    'hours': positiveDecimal,
    'money': negativeDecimal,
    'rate': positiveDecimal,
    'date': {
        getFormat: function() {
            return ep.currentCultureSettings.datePlaceholder;
        },
        maxLength: 10
    }
};